import { $$, on } from "../../utils/dom";

const COLLAPSED_CLASS = "-collapsed";
const VISIBLE_LINES = 5;

export const onContentLoaded = (): void => {
  $$(".js-revisionHistory")?.forEach((root) => {
    const entries = root.querySelector<HTMLElement>(
      ".js-revisionHistory__entries"
    );
    const toggle = root.querySelector<HTMLButtonElement>(
      ".js-revisionHistory__toggle"
    );

    if (!entries || !toggle) {
      return;
    }

    if (entries.querySelectorAll("li, p, br").length <= VISIBLE_LINES) {
      return;
    }

    entries.classList.add(COLLAPSED_CLASS);
    toggle.hidden = false;

    on(toggle, "click", () => {
      const expanded = !entries.classList.toggle(COLLAPSED_CLASS);

      toggle.setAttribute("aria-expanded", String(expanded));
      toggle.textContent =
        (expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel) || "";
    });
  });
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
